module.exports = __webpack_public_path__ + "static/media/elizabeth.4fa2fc92.png";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/elizabeth.png
// module id = 1286
// module chunks = 0